<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="60px" label-position='left' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="姓名" )
                    el-input.inputWidth(v-model='dataForm.name' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="手机" )
                    el-input.inputWidth(v-model='dataForm.phone' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="身份证" )
                    el-input.inputWidth(v-model='dataForm.cardNum' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="主办方" )
                    el-select.inputWidth(v-model="dataForm.userGroupId",placeholder="请选择" filterable clearable )
                        el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )
              el-col(:md='6' :sm="12")
                el-form-item(label="级别")
                    el-select.matchStatus.inputWidth(v-model='dataForm.coachLevel' clearable  )
                        el-option(label="不限" value="")
                        el-option(label="0.0" value="0.0")
                        el-option(label="1.0" value="1.0")
                        el-option(label="1.5" value="1.5")
                        el-option(label="2.0" value="2.0")
                        el-option(label="2.5" value="2.5")
                        el-option(label="3.0" value="3.0")
                        el-option(label="3.5" value="3.5")
                        el-option(label="4.0" value="4.0")
                        el-option(label="4.5" value="4.5")
                        el-option(label="5.0" value="5.0")

              el-col(:md='6' :sm="12")
                el-form-item(label="性别" )
                    el-select.matchStatus.inputWidth(v-model='dataForm.sex' clearable  )
                        el-option(label="男" value="0")
                        el-option(label="女" value="1")
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(@click='addOrUpdateHandle()'  type='primary'  v-if="isAuth('px:coach:add')" ) 新建
                el-button(type='danger' @click='deleteitem(dataListSelections)' :disabled='dataListSelections.length <= 0' v-if="isAuth('px:coach:del')" ) 删除
                el-button(type='primary' @click='exportExcel()') 导出
            el-col( :md='1' :sm="14" style='float:right;')
                el-button(@click='queryList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle')
            el-table-column(type='selection' header-align='center' align='center'  width='50')
            el-table-column(prop='name',header-align='center',align='center',label='姓名')
            el-table-column(prop='phone',header-align='center',align='center',label='手机号')
            el-table-column(prop='cardNum',header-align='center',align='center',label='身份证号')
            el-table-column(prop='orgName',header-align='center',align='center',label='主办方')
            el-table-column(prop='leve',header-align='center',align='center',label='等级')
            el-table-column(prop='coachLevel',header-align='center',align='center',label='级别')
            el-table-column(prop='sex',header-align='center',align='center',label='性别')
               template(slot-scope="scope")
                   span(v-if='scope.row.sex === 0') 男
                   span(v-if='scope.row.sex === 1') 女
            el-table-column(prop='email',header-align='center',align='center',label='邮箱' :show-overflow-tooltip='true')
            el-table-column(prop='byx1',header-align='center',align='center',label='账户关联' )
              template(slot-scope="scope")
                   span(v-if='scope.row.byx1') 已关联
                   span(v-if='!scope.row.byx1') 未关联
            el-table-column(header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1"   type="text" @click='showView(scope.row.id,1)' v-if="isAuth('px:coach:detail')" ) 查看详情
                                el-menu-item(index="1-2" @click="addOrUpdateHandle(scope.row.id,1)"  type="text"  v-if="isAuth('px:coach:update')" ) 修改
                                el-menu-item(index="1-3"  @click='deleteitem(scope.row.id)'  v-if="isAuth('px:coach:del')" ) 删除
                                el-menu-item(index="1-4" @click='showLinkAccount(scope.row)' v-if="isAuth('px:coach:adduser')" ) 关联账户
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //- 添加和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='getDataList')
        //- 查看详情
        queryView(v-if='queryViewVisible', ref="queryView", @refreshDataList='getDataList')
        //- 关联账户
        el-dialog(title="关联账户" :visible.sync="linkFormVisible"  width='40%' :modal-append-to-body='false'  :close-on-click-modal='false')
          el-form(:model="addLinkFrom" ref="linkform" :rules="LinkFromRule" label-width='110px')
            el-form-item(label="姓名:"  prop="name")
                el-input.inputWidth_g(type="text" v-model="addLinkFrom.name" disabled)
            el-form-item(label="身份证号:" prop="idCard")
                el-input.inputWidth_g(type="text" v-model="addLinkFrom.idCard" disabled)
            el-form-item(label="关联账号:" prop="account")
                el-input.inputWidth_g(type="text" v-model="addLinkFrom.account" @blur='changeAccount')
            el-form-item(label="关联会员:" prop="linkPerson")
                el-input.inputWidth_g(type="text" v-model="addLinkFrom.linkPerson" @blur='changeAccount')
            el-row(style='margin-top:30px;')
              el-col(align='center')
                el-button(type="primary" @click="addLink") 确认
                el-button(@click="linkFormVisible=false" style='margin-left:50px;') 取消
</template>

<script>
import table from './table.js'
import AddOrUpdate from './add-or-update'
import queryView from './query-view'
import { isMobile } from '../../../util/validate'

export default {
  name: 'single',
  data () {
    return {
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      linkFormVisible: false,
      isCollapse: true,
      loading: null,
      addOrUpdateVisible: false,
      queryViewVisible: false,
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataForm: {
        vacateName: '',
        vacateId: '',
        trainName: '',
        trainId: '',
        trainType: '',
        orgName: '' //主办方
      },
      addLinkFrom: {
        name: '',
        idCard: '',
        account: '',
        linkPerson: ''
      },
      coach: {}, //当前选择的教练
      LinkFromRule: {
        account: [
          { required: true, message: '必须填写关联账户!', trigger: 'blur' }
        ],
        linkPerson: [
          { required: true, message: '必须填写会员!', trigger: 'blur' }
        ]
      },
      dataListSelections: [],
      sysOrgList: []
    }
  },
  components: {
    AddOrUpdate,
    queryView
  },
  mounted () {
    this.getDataList()
    this.initCity()
  },
  methods: {
    addLink () {
      this.$refs.linkform.validate((v) => {
        if (v) {
          console.log(this.addLinkFrom)
          if (this.addLinkFrom.account && isMobile(this.addLinkFrom.account)) {
            this.openFullScreen()
            this.$http({
              url: this.$http.adornUrl(`/mbMember/getMbByMobile`),
              method: 'get',
              params: this.$http.adornParams({
                mobile: this.addLinkFrom.account,
                name: this.addLinkFrom.linkPerson
              })
            }).then((data) => {
              if (data && data.code === 0) {
                if (data.list != null && data.list.length > 0) {
                  this.coach.byx1 = data.list[0].id
                  this.$http({
                    url: this.$http.adornUrl(`/pxCoach/update`),
                    method: 'post',
                    data: this.coach
                  }).then((data) => {
                    if (data && data.code === 0) {
                      this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                          this.linkFormVisible = false
                          this.getDataList()
                          this.loading.close()
                        }
                      })
                    } else {
                      this.$message.error(data.msg)
                      this.loading.close()
                    }
                  })
                } else {
                  this.$message.error('未找到会员信息')
                  this.loading.close()
                }
              }
            })
          }
        }
      })
    },
    changeAccount () {
      if (this.addLinkFrom.account && isMobile(this.addLinkFrom.account)) {
        this.$http({
          url: this.$http.adornUrl(`/mbMember/getMbByMobile`),
          method: 'get',
          params: this.$http.adornParams({
            mobile: this.addLinkFrom.account,
            name: this.addLinkFrom.linkPerson
          })
        }).then((data) => {
          if (data && data.code === 0) {
            if (data.list != null && data.list.length > 0) {
            } else {
              this.$message.error('未找到会员信息')
            }
          }
        })
      }
    },
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 关联账户设置
    showLinkAccount (row) {
      this.linkFormVisible = true
      this.coach = row
      this.addLinkFrom.name = row.name
      this.addLinkFrom.idCard = row.cardNum
      this.addLinkFrom.linkPerson = ''
      this.addLinkFrom.account = ''
      if (row.byx1) {
        //根据会员id查询会员信息
        this.$http({
          url: this.$http.adornUrl(`/mbMember/getId/${row.byx1}`),
          method: 'get',
          params: this.$http.adornParams()
        }).then((data) => {
          console.log('初始化信息', data)
          if (data && data.code === 0) {
            this.addLinkFrom.linkPerson = data.bean.name
            this.addLinkFrom.account = data.bean.mobile
          }
        })
      }
    },
    deleteClick (type, rows) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    queryList () {
      this.pageIndex = 1
      this.getDataList()
    },
    //添加或修改事件
    addOrUpdateHandle (id, flagType) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, flagType)
      })
    },
    showView (id, flagType) {
      this.queryViewVisible = true
      this.$nextTick(() => {
        this.$refs.queryView.init(id, flagType)
      })
    },
    // 删除
    deleteitem (id) {
      if (typeof id !== 'string') {
        if (id.length === 0) return this.$message.error('未勾选任何项目！')
        let ids = []
        id.forEach((e) => {
          ids.push(e.id)
        })
        id = ids.join()
      }
      this.$confirm('删除教练信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl(`/pxCoach/delete/${id}`),
            method: 'get',
            params: this.$http.adornParams()
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message.success('删除成功!')
              this.getDataList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 导出
    exportExcel () {
      this.$http({
        url: this.$http.adornUrl('/pxCoach/getExportList'),
        method: 'post',
        data: {
          name: this.dataForm.name || null,
          phone: this.dataForm.phone || null,
          cardNum: this.dataForm.cardNum || null,
          userGroupId: this.dataForm.userGroupId || null,
          coachLevel: this.dataForm.coachLevel || null,
          sex: this.dataForm.sex || null
        }
      }).then((data) => {
        if (data && data.code === 0) {
          console.log(data.list)
          if (data.list == null || data.list.length === 0) {
            this.$message.info('没有要导出的数据!')
            return
          }
          let exportData = data.list
          for (let i of exportData) {
            i.sex = { 0: '男', 1: '女' }[i.sex]
          }
          console.log('导出的订单数据：', exportData)
          this.$export
            .excel({
              columns: this.table.columns,
              data: exportData,
              title: '教练信息'
            })
            .then(() => {
              this.$message.success('导出表格成功')
            })
        }
      })
    },
    getDataList () {
      this.dataListLoading = true

      this.$http({
        url: this.$http.adornUrl('/pxCoach/list'),
        method: 'post',
        data: {
          page: this.pageIndex,
          rows: this.pageSize,
          name: this.dataForm.name || null,
          phone: this.dataForm.phone || null,
          cardNum: this.dataForm.cardNum || null,
          userGroupId: this.dataForm.userGroupId || null,
          coachLevel: this.dataForm.coachLevel || null,
          sex: this.dataForm.sex || null,
          limit: this.pageSize
        }
      }).then((data) => {
        if (data && data.code === 0) {
          this.tableData = data.page.records
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    }
  }
}
</script>
<style >
/* 操作三点 菜单样式 */
@import '../../css/opr3dot.css';

.inputWidth {
  width: 200px;
}
.inputWidth_g {
  width: 75%;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: grey !important ;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}

.el-dialog {
  position: relative;
  margin: 0 auto 80px;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
}
</style>
